import type { MessageDescriptor } from "@lingui/core";
import { defineMessage as dm } from "@lingui/core/macro";

export type PlaceLabel = Record<string, MessageDescriptor>;

const commonPlaceLabels: PlaceLabel = {
  HOME: dm`Home`,
  WORK: dm`Work`,
  OTHER: dm`Other`,
};

export const ContactPhonePlaceLabels: PlaceLabel = {
  ...commonPlaceLabels,
  MAIN: dm`Main`,
  "HOME,VOICE": dm`Home`,
  "WORK,VOICE": dm`Work`,
  CELL: dm`Mobile`,
  FAX: dm`Fax`,
  "HOME,FAX": dm`Home Fax`,
  "WORK,FAX": dm`Work Fax`,
  PAGER: dm`Pager`,
  VOICE: dm`Voice`,
};

export const ContactEmailPlaceLabels: PlaceLabel = {
  ...commonPlaceLabels,
};

export const ContactUrlPlaceLabels: PlaceLabel = {
  ...commonPlaceLabels,
};

export const ContactAddressPlaceLabels: PlaceLabel = {
  ...commonPlaceLabels,
  INTERVENTION: dm`Intervention`,
  BILLING: dm`Billing`,
  DELIVERY: dm`Delivery`,
};

export const SearchFieldLabels: PlaceLabel = {
  all: dm`All fields`,
  name: dm`Name`,
  email: dm`Email`,
  phone: dm`Phone`,
};

export const CategoryFilterLabel = dm`Category`;

export const SearchFieldFilterLabel = dm`Search field`;

export const RelationEntityLabels: PlaceLabel = {
  client: dm`Clients`,
  employee: dm`Employees`,
  supplier: dm`Suppliers`,
  subcontractor: dm`Subcontractors`,
  subscription: dm`Subscriptions`,
  intervention: dm`Interventions`,
};

export const ContactPreviewLabel = dm`Contact details`;

export const ContactPreviewLoadingLabel = dm`Loading the contact`;
